export default "__VITE_ASSET__a856a676__"